import React from 'react';
import Box from '@mui/material/Box';

const coloredEmojiById = {
  animal_cat: '🐱',
  animal_dog: '🐶',
  animal_mouse: '🐭',
  animal_rabbit: '🐰',
  animal_fox: '🦊',
  fruit_apple: '🍎',
  fruit_pear: '🍐',
  fruit_orange: '🍊',
  fruit_strawberry: '🍓',
  fruit_watermelon: '🍉',
  nature_sun: '☀️',
  nature_cloud: '☁️',
  nature_flower: '🌼',
  nature_leaf: '🍃',
  nature_moon: '🌙',
  vehicle_car: '🚗',
  vehicle_bus: '🚌',
  vehicle_bicycle: '🚲',
  vehicle_boat: '⛵',
  vehicle_train: '🚆',
};

export default function PatternLibrarySymbol({ value, decorative = false }) {
  const symbolId = String(value?.symbol_id || '');
  const glyph = coloredEmojiById[symbolId] || value?.fallback_glyph || '?';

  return (
    <Box
      component="span"
      role={decorative ? undefined : 'img'}
      aria-hidden={decorative || undefined}
      aria-label={decorative ? undefined : value?.label || 'desen sembolü'}
      sx={{
        width: '1em',
        height: '1em',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif',
        fontSize: '1em',
        fontWeight: 400,
        lineHeight: 1,
        textRendering: 'optimizeLegibility',
      }}
    >
      {glyph}
    </Box>
  );
}
